import React, { useState } from "react";
import { menuTabs, menuData } from "../mock";
import MenuItem from "./MenuItem";

export default function Menu() {
  const [active, setActive] = useState("coffee");
  const panel = menuData[active];

  return (
    <section id="menu">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow" data-reveal="fade">On the table</span>
          <h2 data-reveal="fade" data-reveal-delay="1">A menu with two passports.</h2>
          <p data-reveal="fade" data-reveal-delay="2">
            Everything is cooked to order across our three counters. Ask your server if you'd like a
            dish milder, meat-free, or louder on the chilli.
          </p>
        </div>

        <div className="menu-tabs" role="tablist">
          {menuTabs.map((t) => (
            <button
              key={t.id}
              className={`menu-tab${active === t.id ? " active" : ""}`}
              onClick={() => setActive(t.id)}
              role="tab"
              aria-selected={active === t.id}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="menu-panel active" key={active}>
          <div className="menu-panel-head">
            <h3>{panel.heading}</h3>
            <p>{panel.sub}</p>
          </div>
          <div className="menu-list">
            {panel.items.map((item) => (
              <MenuItem item={item} key={item.name} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
